import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppV2 from './App';
import ToastContainer from './components/ToastContainer';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <>
      <AppV2 />
      <ToastContainer />
    </>
  </React.StrictMode>
);
